Redactor.addLang('ru', {
    "accessibility": { "help-label": "Редактор форматированного текста" },
    "placeholders": { "figcaption": "Введите подпись (необязательно)" },
    "embed": {
        "embed": "Вставка",
        "title": "Заголовок",
        "poster": "Постер",
        "caption": "Подпись",
        "description": "Вставьте код embed/html или введите URL (только видео Vimeo или YouTube)",
        "responsive-video": "Адаптивное видео"
    },
    "image": {
        "tab-select": "Выбрать",
        "tab-upload": "Загрузить",
        "tab-url": "URL",
        "tab-props": "Свойства",
        "alt-text": "Альтернативный текст",
        "link": "Ссылка",
        "src": "Источник",
        "width": "Ширина",
        "height": "Высота",
        "caption": "Подпись",
        "link-in-new-tab": "Открыть ссылку в новой вкладке",
        "url-placeholder": "Вставьте URL изображения...",
        "upload-new-placeholder": "Перетащите для загрузки нового изображения<br>или нажмите для выбора"
    },
    "list": { "select-list": "Выбрать список" },
    "link": {
        "link": "Ссылка",
        "edit-link": "Изменить ссылку",
        "unlink": "Удалить ссылку",
        "link-in-new-tab": "Открыть в новой вкладке",
        "text": "Текст",
        "url": "URL"
    },
    "table": {
        "width": "Ширина (px или %)",
        "nowrap": "Без переноса",
        "table-cell": "Ячейка таблицы",
        "select-table": "Выделить таблицу",
        "select-cell": "Выделить ячейку",
        "cell-setting": "Настройки ячейки",
        "add-caption": "Добавить заголовок",
        "add-head": "Добавить шапку",
        "add-head-vertical": "Добавить вертикальную шапку",
        "remove-caption": "Удалить заголовок",
        "remove-head": "Удалить шапку",
        "remove-head-vertical": "Удалить вертикальную шапку",
        "add-row-below": "Добавить строку снизу",
        "add-row-above": "Добавить строку сверху",
        "remove-row": "Удалить строку",
        "add-column-after": "Добавить столбец после",
        "add-column-before": "Добавить столбец перед",
        "remove-column": "Удалить столбец",
        "delete-table": "Удалить таблицу",
        "merge-cells": "Объединить ячейки",
        "split-into-rows": "Разделить на строки",
        "split-into-columns": "Разделить на столбцы",
        "caption-placeholder": "Заголовок..."
    },
    "buttons": {
        "add": "Добавить",
        "insert": "Вставить",
        "save": "Сохранить",
        "cancel": "Отмена",
        "delete": "Удалить",
        "ai-tools": "Инструменты ИИ",
        "ai-image": "Изображение ИИ",
        "html": "HTML",
        "format": "Формат",
        "bold": "Жирный",
        "italic": "Курсив",
        "deleted": "Зачёркнутый",
        "more-formatting": "Ещё форматирование",
        "link": "Ссылка",
        "link-text": "Текст ссылки",
        "unlink": "Удалить ссылку",
        "image": "Изображение",
        "unwrap": "Убрать обёртку",
        "outset": "Выступ",
        "wrap-image": "Обтекание",
        "move-up": "Переместить вверх",
        "move-down": "Переместить вниз",
        "list": "Список",
        "numbered-list": "Нумерованный список",
        "bullet-list": "Маркированный список",
        "indent": "Отступ",
        "outdent": "Уменьшить отступ",
        "definition-list": "Список определений",
        "hotkeys": "Горячие клавиши",
        "undo": "Отменить",
        "redo": "Повторить",
        "toggle": "Переключить",
        "duplicate": "Дублировать",
        "table": "Таблица",
        "embed": "Вставка",
        "quote": "Цитата",
        "layout": "Макет",
        "wrapper": "Обёртка",
        "todo": "Список задач",
        "code-snippet": "Фрагмент кода",
        "line": "Разделитель",
        "parent": "Родитель",
        "code": "Код",
        "underline": "Подчёркнутый",
        "highlight": "Выделение",
        "superscript": "Надстрочный",
        "subscript": "Подстрочный",
        "clear-all-styles": "Очистить стили",
        "heading": "Заголовок",
        "text": "Текст",
        "address": "Адрес"
    },
    "colorpicker": {
        "remove-color": "Убрать цвет",
        "remove-background": "Убрать цвет фона",
        "color": "Цвет",
        "background": "Фон",
        "set-color": "Установить цвет"
    },
    "pathbar": { "title": "Текст" },
    "layout": {
        "select-layout": "Выбрать макет",
        "select-column": "Выбрать столбец",
        "single-column": "Один столбец",
        "two-columns": "Два столбца",
        "three-columns": "Три столбца",
        "four-columns": "Четыре столбца"
    },
    "outset": {
        "outset-none": "Без выступа",
        "outset-left": "Выступ влево",
        "outset-both": "Выступ с обеих сторон",
        "outset-right": "Выступ вправо"
    },
    "wrap": {
        "wrap-none": "Без обтекания",
        "wrap-left": "Обтекание слева",
        "wrap-center": "Обтекание по центру",
        "wrap-right": "Обтекание справа"
    },
    "blocks": {
        "address": "Адрес",
        "cell": "Ячейка",
        "column": "Столбец",
        "dlist": "Список определений",
        "embed": "Вставка",
        "figcaption": "Подпись к рисунку",
        "heading": "Заголовок",
        "image": "Изображение",
        "wrapper": "Обёртка",
        "layout": "Макет",
        "line": "Разделитель",
        "list": "Список",
        "listitem": "Элемент",
        "noneditable": "Нередактируемый",
        "pre": "Преформатированный",
        "quote": "Цитата",
        "row": "Строка",
        "table": "Таблица",
        "text": "Текст",
        "todo": "Задача",
        "todoitem": "Элемент",
        "mergetag": "Тег слияния",
        "caption": "Подпись"
    },
    "hotkeys": {
        "meta-shift-a": "Выделить текст в блоке",
        "meta-a": "Выделить все блоки",
        "meta-z": "Отменить",
        "meta-shift-z": "Повторить",
        "meta-shift-m": "Убрать форматирование",
        "meta-b": "Жирный",
        "meta-i": "Курсив",
        "meta-u": "Подчёркнутый",
        "meta-h": "Надстрочный",
        "meta-l": "Подстрочный",
        "meta-k": "Ссылка",
        "meta-alt-0": "Обычный текст",
        "meta-alt-1": "Заголовок 1",
        "meta-alt-2": "Заголовок 2",
        "meta-alt-3": "Заголовок 3",
        "meta-alt-4": "Заголовок 4",
        "meta-alt-5": "Заголовок 5",
        "meta-alt-6": "Заголовок 6",
        "meta-shift-7": "Нумерованный список",
        "meta-shift-8": "Маркированный список",
        "meta-indent": "Отступ",
        "meta-outdent": "Уменьшить отступ",
        "meta-shift-backspace": "Удалить блок",
        "meta-shift-o": "Добавить блок",
        "meta-shift-d": "Дублировать блок",
        "meta-shift-up": "Переместить строку вверх",
        "meta-shift-down": "Переместить строку вниз"
    },
    "alignment": {
        "alignment": "Выравнивание",
        "left": "По левому краю",
        "center": "По центру",
        "right": "По правому краю",
        "justify": "По ширине"
    },
    "blockcolor": { "color": "Цвет текста" },
    "blockbackground": { "background-color": "Цвет фона" },
    "counter": { "words": "слов", "chars": "символов" },
    "imageresize": { "image-resize": "Изменить размер изображения" },
    "emoji": {
        "emoji": "Эмодзи",
        "favorites": "Избранное",
        "smileys": "Смайлы",
        "gestures": "Жесты",
        "animals": "Животные",
        "food": "Еда",
        "activities": "Занятия",
        "travel": "Путешествия"
    },
    "filelink": {
        "file": "Файл",
        "upload": "Загрузить",
        "title": "Текст ссылки",
        "select": "Выбрать",
        "placeholder": "Перетащите для загрузки файла<br>или нажмите для выбора"
    },
    "find-replace": {
        "find-replace": "Найти и заменить",
        "done": "Готово",
        "search-placeholder": "Поиск...",
        "replace-placeholder": "Заменить...",
        "replace": "Заменить",
        "replace-all": "Заменить все",
        "of": "из"
    }
});
